
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";

// export default createVuetify(
//   // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides

// )
// import colors from "vuetify/util/colors";

export default createVuetify({
    // theme: {
    //     defaultTheme: "light",
    //     themes: {
    //         dark: {
    //             colors: {
    //                 primary: "#27293D",
    //                 secondary: "#DA50D3",
    //                 accent: "#F23739",
    //                 appBg: "#1F1F2F",
    //             },
    //         },
    //     },
    // },
    breakpoint: {
        mobileBreakpoint: 0,
        thresholds: {
            xs: 0,
            sm: 0,
            md: 0,
            lg: 0, // was 1920
            xl: 0,
        },
        // scrollBarWidth: 5,
    },
    icons: {},
    components: {},
});
